import {
  useDomainOptions,
  type DomainOption,
} from '@components/FormDomainSelect';
import {
  useCanEditGovernanceDomain,
  useGovernanceAccess,
} from '@/hooks/useGovernanceAccess';

export function filterEditableGovernanceDomainOptions(
  options: DomainOption[],
  canEditDomain: (domainId: number) => boolean,
): DomainOption[] {
  return options.filter(({ id }) => canEditDomain(id));
}

/**
 * Domain choices for policy forms; privileged users retain admin search.
 *
 * `referencedIds` are the domains the policy already covers; the licence
 * bootstrap only holds a bounded window, so they are requested explicitly to
 * keep a scoped domain from dropping out of the picker.
 */
export function useEditableGovernanceDomainOptions(
  referencedIds: number[] = [],
): DomainOption[] | undefined {
  const governanceAccess = useGovernanceAccess();
  const canEditDomain = useCanEditGovernanceDomain();
  const availableDomainOptions = useDomainOptions(referencedIds);

  return governanceAccess.isPrivileged
    ? undefined
    : filterEditableGovernanceDomainOptions(
        availableDomainOptions,
        canEditDomain,
      );
}
